import React, {useEffect, useState} from 'react';
import {autorun} from "mobx";
import {PauseIcon} from "../../../../assets/icons/PauseIcon";
import {PlayIcon} from "../../../../assets/icons/PlayIcon";
import {ScissorsIcon} from "../../../../assets/icons/ScissorsIcon";
import {TrashIcon} from "../../../../assets/icons/TrashIcon";
import {ZoomInIcon} from "../../../../assets/icons/ZoomInIcon";
import {ZoomOutIcon} from "../../../../assets/icons/ZoomOutIcon";
import {UndoIcon} from "../../../../assets/icons/UndoIcon";
import {RedoIcon} from "../../../../assets/icons/RedoIcon";
import {RangeIcon} from "../../../../assets/icons/RangeIcon";
import {CompositionService} from "../../../../services/CompositionService";
import {ApplicationStore} from "../../../../store/ApplicationStore";
import {CompositionStore} from "../../../../store/CompositionStore";
import {TimelineStore} from "../../../../store/TimelineStore";
import {secondsToTimecode} from "../../../../utils/secondsToTimecode";
import './Controls.styles.scss';
import Paper from '../../../../components/Paper/Paper';
import Button from "../../../../components/Button/Button";
import Tooltip from "@mui/material/Tooltip";

const Controls = ({timelineHidden, toggleTimelineHide}) => {
    const [isPlaying, setIsPlaying] = useState(CompositionStore.isPlaying);
    const [displayTime, setDisplayTime] = useState(secondsToTimecode(CompositionStore.currentTime, true));
    const [selectedLibrettoClipId, setSelectedLibrettoClipId] = useState(ApplicationStore.selectedLibrettoClipId);
    const [selectedTransitionId, setSelectedTransitionId] = useState(ApplicationStore.selectedTransitionId);
    const [canUndo, setCanUndo] = useState(CompositionStore.canUndo);
    const [canRedo, setCanRedo] = useState(CompositionStore.canRedo);
    const [rangeEnabled, setRangeEnabled] = useState<boolean>(ApplicationStore.rangeToolEnabled);

    useEffect(() => {
        const dispose = autorun(() => {
            setIsPlaying(CompositionStore.isPlaying);
            setSelectedLibrettoClipId(ApplicationStore.selectedLibrettoClipId);
            setSelectedTransitionId(ApplicationStore.selectedTransitionId);
            setDisplayTime(secondsToTimecode(CompositionStore.currentTime, true));
            setCanUndo(CompositionStore.canUndo);
            setCanRedo(CompositionStore.canRedo);
            setRangeEnabled(ApplicationStore.rangeToolEnabled);
        });

        return () => dispose();
    }, []);

    const handlePlay = () => CompositionService.play();
    const handlePause = () => CompositionService.pause();
    const handleTrash = () => CompositionService.deleteLibrettoClipAtCurrentTime();
    const handleSplit = () => CompositionService.splitLibrettoClipAtCurrentTime();
    const decrementZoom = () => TimelineStore.setZoom(TimelineStore.zoom - 0.1);
    const incrementZoom = () => TimelineStore.setZoom(TimelineStore.zoom + 0.1);
    const handleStop = () => {
        if (isPlaying) {
            CompositionService.pause();
        }
        CompositionService.seek(0);
    };
    const handleUndo = async () => {
        // await RendleyService.getEngine().getUndoManager().undo();
    };
    const handleRedo = async () => {
        // await RendleyService.getEngine().getUndoManager().redo();
    };

    const handleToggleRange = () => {
        ApplicationStore.setRangeToolEnabled(!ApplicationStore.rangeToolEnabled);
    };

    const isClipSelected = selectedLibrettoClipId != null;
    const isTransitionSelected = selectedTransitionId != null;
    const isSplitEnabled = isClipSelected;
    const isRangeToolEnabled = isClipSelected;
    const isTrashEnabled = isClipSelected || isTransitionSelected;

    return (
        <Paper>
            <div className="controls">
                <div className="controls__section">
                    {timelineHidden ?
                        <Button onClick={toggleTimelineHide}>
                            {"Show timeline"}
                        </Button> : <Button onClick={toggleTimelineHide}>{"Hide Timeline"}</Button>}


                    {/*<Button disabled={!isTrashEnabled} onClick={handleTrash}>*/}
                    {/*  <TrashIcon />*/}
                    {/*</Button>*/}
                </div>

                <div className="controls__section">
                    <Button onClick={handleStop}>
                        <div className="controls__section--stop-btn"></div>
                    </Button>

                    {isPlaying ? (
                        <Button onClick={handlePause}>
                            <PauseIcon/>
                        </Button>
                    ) : (
                        <Button onClick={handlePlay}>
                            <PlayIcon/>
                        </Button>
                    )}
                    <span className="controls__playback__time">{displayTime}</span>
                </div>

                <div className="controls__section">

                    <Button disabled={!isSplitEnabled} onClick={handleSplit} title={"Blade"}>
                        <ScissorsIcon/>
                    </Button>

                    <Button disabled={!isRangeToolEnabled} onMouseDown={handleToggleRange} variant={rangeEnabled ? "primary" : "ghost"} title={"Range"}>
                        <RangeIcon/>
                    </Button>

                </div>
            </div>
        </Paper>
    );
};

export default Controls;